import { useCallback, useRef } from 'react';
import { useCopilotRuntimeOptional } from '@/components/agent-chat/copilot-runtime-provider.component';

/**
 * Reads the open agent chat again after the user changed the play outside
 * it: Accept or Discard of a proposal, or a save on the canvas. The server
 * posts a line about each into the chat, which Clu reads in its next turn, so
 * the user sees it too. Only when the open chat is `conversationId` (any
 * saved open chat when it isn't given), and never while a turn streams: the
 * line is in the chat the next time it opens.
 */
export function useRefreshAgentChat(): (
  conversationId?: string | null
) => void {
  const runtime = useCopilotRuntimeOptional();
  const latest = useRef(runtime);
  latest.current = runtime;
  return useCallback((conversationId?: string | null) => {
    const chat = latest.current;
    if (!chat || chat.isStreaming || !chat.conversationId) return;
    if (conversationId !== undefined && conversationId !== chat.conversationId)
      return;
    void chat.loadConversation(chat.conversationId);
  }, []);
}
